"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PivotTableDivider = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styles_1 = __importDefault(require("./styles"));
// TODO: Handle None option for empty value array
var PivotTableDivider = function () {
    var classes = (0, styles_1.default)();
    return (0, jsx_runtime_1.jsx)("div", __assign({ className: classes.sectionHeader }, { children: "\u00A0" }));
};
exports.PivotTableDivider = PivotTableDivider;
